import type { IFieldDefinition, IRecordTypeDefinition } from '@platform/core/types';

/**
 * Поле статті Markdown (UIUX/field-types/rich-text): тип richtext (коли метадані його матимуть) або текст статті бази знань — довгий
 * текст `body` типу запису з поданням «Бібліотека».
 */
export function isRichTextField(field: IFieldDefinition, rt: IRecordTypeDefinition): boolean {
  if ((field.type as string) === 'richtext') return true;
  return field.type === 'textarea' && field.key === 'body' && Boolean(rt.views?.custom?.includes('library'));
}
